import { createStore, applyMiddleware } from "redux";

import { composeWithDevTools } from "redux-devtools-extension";
import ReduxThunk from "redux-thunk";
import createSagaMiddleware from "redux-saga";

import rootReducer from "./reducers";
import rootSaga from "./saga";

const sagaMiddleware = createSagaMiddleware();

export function startSaga() {
  // initialise les différents générateurs saga disponibles dans l'application
  sagaMiddleware.run(rootSaga);
}

// création du store avec redux-thunk & redux-saga comme middleware
const store = createStore(rootReducer, applyMiddleware(ReduxThunk, sagaMiddleware));

export default store;
